// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.travel-service-chips {\n  /*max-width: 150px;*/\n  height: auto !important;\n}\n.travel-service-chips .v-chip__content {\n  height: auto;\n  white-space: normal;\n}\n", ""]);
// Exports
module.exports = exports;
